import { useParams } from "react-router-dom";
import { ClaimHelper, LocalStorageHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { useCommunity } from "../../../context/communityContext";

export const resolveBannerCommunityId = ( ...communityIds: Array<string | null | undefined> ): string | undefined =>
  communityIds.find( (communityId) => !!communityId && communityId !== Constants.emptyGuid, ) ?? undefined;

export const useResolvedBannerCommunityId = ( explicitCommunityId?: string | null, dataCommunityId?: string | null, ): string | undefined => {
  const { communityId: paramCommunityId } = useParams();
  const { communityId } = useCommunity();

  return resolveBannerCommunityId(
    explicitCommunityId,
    dataCommunityId,
    paramCommunityId,
    ClaimHelper.getCommunityId(),
    communityId,
    LocalStorageHelper.getCommunityId(),
  );
};
